import { makeStyles } from "@material-ui/core"
import { themeColors } from "letalkui"

import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles(() => ({
	header: {
		padding: "28px 32px 0",
		position: "relative"
	},
	badge: {
		display: "inline-flex",
		alignItems: "center",
		gap: 8,
		padding: "6px 14px",
		borderRadius: 999,
		backgroundColor: themeColors.colors.system.purple[50],
		color: themeColors.colors.system.gray[900],
		fontSize: "11.5px",
		fontWeight: 700,
		letterSpacing: "0.08em",
		textTransform: "uppercase"
	},
	badgeIcon: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		width: 22,
		height: 22,
		borderRadius: "50%",
		backgroundColor: themeColors.colors.system.purple[500],
		color: themeColors.colors.system.gray[50],
		fontSize: "11px",
		fontWeight: 700
	},
	title: {
		marginTop: 16,
		color: themeColors.colors.system.gray[900],
		fontSize: "24px",
		fontWeight: 500,
		lineHeight: 1.3,
		letterSpacing: "-0.015em"
	},
	subtitle: {
		marginTop: 10,
		color: themeColors.colors.system.gray[600],
		fontSize: "14.5px",
		fontWeight: 400,
		lineHeight: 1.6
	},
	formCard: {
		margin: "22px 32px 0",
		backgroundColor: themeColors.colors.system.gray[50],
		border: `1px solid ${themeColors.colors.system.gray[100]}`,
		borderRadius: 14,
		padding: "20px 22px"
	},
	fieldLabel: {
		color: themeColors.colors.system.gray[900],
		fontSize: "15px",
		fontWeight: 600,
		marginBottom: 12
	},
	fieldsGrid: {
		display: "grid",
		gridTemplateColumns: "1fr 1fr",
		gap: 12,
		marginTop: 12
	},
	fullWidthField: {
		gridColumn: "1 / -1"
	},
	inputRoot: {
		height: 48,
		borderRadius: 10,
		border: `1.5px solid ${themeColors.colors.system.gray[200]}`,
		padding: "0 14px",
		fontSize: "14.5px",
		color: themeColors.colors.system.gray[900],
		backgroundColor: themeColors.colors.system.gray[50],
		transition: "border-color 0.2s ease",
		"&:hover": {
			borderColor: themeColors.colors.system.purple[500]
		},
		"&$inputFocused": {
			borderColor: themeColors.colors.system.purple[500]
		}
	},
	inputFocused: {},
	inputError: {
		borderColor: themeColors.colors.error[300]
	},
	inputRootError: {
		borderColor: themeColors.colors.error[300]
	},
	errorText: {
		color: themeColors.colors.error[700],
		fontSize: "11.5px",
		marginTop: 4,
		lineHeight: 1.4
	},
	phoneWrapper: {
		position: "relative"
	},
	dividerSection: {
		display: "flex",
		alignItems: "center",
		gap: 12,
		marginTop: 20,
		marginBottom: 14
	},
	dividerLabel: {
		color: themeColors.colors.system.gray[400],
		fontSize: "11px",
		fontWeight: 700,
		letterSpacing: "0.1em",
		textTransform: "uppercase",
		whiteSpace: "nowrap"
	},
	dividerLine: {
		flex: 1,
		height: 1,
		backgroundColor: themeColors.colors.system.gray[100]
	},
	optionsGrid: {
		display: "grid",
		gridTemplateColumns: "1fr 1fr",
		gap: 10
	},
	optionCard: {
		display: "flex",
		alignItems: "center",
		gap: 10,
		padding: "13px 14px",
		borderRadius: 10,
		border: `1.5px solid ${themeColors.colors.system.gray[100]}`,
		backgroundColor: themeColors.colors.system.gray[50],
		cursor: "pointer",
		transition: "all 0.2s ease"
	},
	optionCardSelected: {
		borderColor: themeColors.colors.system.purple[500],
		backgroundColor: themeColors.colors.system.purple[50]
	},
	radioOuter: {
		width: 18,
		height: 18,
		borderRadius: "50%",
		border: `2px solid ${themeColors.colors.system.purple[200]}`,
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		flexShrink: 0,
		transition: "border-color 0.2s ease"
	},
	radioOuterSelected: {
		borderColor: themeColors.colors.system.purple[500]
	},
	radioInner: {
		width: 10,
		height: 10,
		borderRadius: "50%",
		backgroundColor: themeColors.colors.system.purple[500]
	},
	optionLabel: {
		fontSize: "14.5px",
		fontWeight: 500,
		color: themeColors.colors.system.gray[900]
	},
	helperText: {
		marginTop: 14,
		fontSize: "13px",
		color: themeColors.colors.system.gray[400],
		lineHeight: 1.5
	},
	footer: {
		display: "flex",
		justifyContent: "flex-end",
		alignItems: "center",
		gap: 20,
		padding: "20px 32px 26px"
	},
	dontRememberLink: {
		background: "none",
		border: "none",
		color: themeColors.colors.system.gray[600],
		fontSize: "13px",
		fontWeight: 400,
		cursor: "pointer",
		textAlign: "right",
		lineHeight: 1.5,
		padding: 0,
		transition: "color 0.2s ease",
		"&:hover": {
			color: themeColors.colors.system.gray[900]
		}
	},
	submitButton: {
		padding: "15px 24px",
		borderRadius: 12,
		border: "none",
		backgroundColor: themeColors.colors.system.purple[500],
		color: themeColors.colors.system.gray[50],
		fontSize: "15.5px",
		fontWeight: 600,
		cursor: "pointer",
		boxShadow: `0 12px 26px ${ColorUtil.hexToRgba(colors.purple[400], 0.3)}`,
		transition: "background-color 0.2s ease",
		whiteSpace: "nowrap",
		"&:hover": {
			backgroundColor: themeColors.colors.system.purple[600]
		}
	},
	submitButtonDisabled: {
		backgroundColor: themeColors.colors.system.purple[200],
		cursor: "not-allowed",
		boxShadow: "none",
		"&:hover": {
			backgroundColor: themeColors.colors.system.purple[200]
		}
	}
}))

export default useStyles
